var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { range, TSS_BLUE_1, TSS_BLUE_2, TSS_DARK_BLUE, stylePropType, getScrollParent } from 'tss-core-lib-common';
import ClickOutside from './ClickOutside';

import Menu from './Menu';

var styles = void 0;
var selectorBottom = 250;

var TemperatureSelect = function (_Component) {
  _inherits(TemperatureSelect, _Component);

  function TemperatureSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TemperatureSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TemperatureSelect.__proto__ || Object.getPrototypeOf(TemperatureSelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getValues = function () {
      if (_this.props.value === null) {
        return { integerPart: 0, floatPart: 0, negative: false };
      }

      var negative = 1 / _this.props.value < 0;
      var integerPart = parseInt(_this.props.value.toString(), 10);
      var floatPart = Math.round(Math.abs(_this.props.value - integerPart) * 10) / 10;

      return { integerPart: integerPart, floatPart: floatPart, negative: negative };
    }, _this.setMainRef = function (ref) {
      _this.main = ref;
    }, _this.handleClickOutside = function (event) {
      if (event.target !== _this.main && !_this.main.contains(event.target)) {
        _this.setState({ integerOpen: false, floatOpen: false, floatAbove: false, integerAbove: false });
      }
    }, _this.handleIntegerClick = function (event) {
      var _event$target$getBoun = event.target.getBoundingClientRect(),
          bottom = _event$target$getBoun.bottom;

      var scrollParent = getScrollParent(event.target);
      var height = window.innerHeight;
      if (scrollParent) {
        height = scrollParent.getBoundingClientRect().bottom;
      }
      var integerAbove = bottom + selectorBottom > height;
      _this.setState({ integerOpen: true, floatOpen: false, integerAbove: integerAbove });
    }, _this.handleIntegerItemClick = function (strValue, event) {
      event.stopPropagation();

      _this.setState({ integerOpen: false });
      if (_this.props.onChange) {
        var _this$getValues = _this.getValues(),
            floatPart = _this$getValues.floatPart;

        var value = parseInt(strValue, 10);
        var negative = value <= -0.0000001 || strValue === '-0';
        if (_this.props.type === 'min') {
          _this.props.handleNegative(_this.props.type, negative);
        }
        if (_this.props.type === 'max') {
          _this.props.handleNegative(_this.props.type, negative);
        }
        var actualValue = (Math.abs(value) + floatPart) * (negative ? -1 : 1);
        if (_this.props.max !== null) {
          actualValue = Math.min(_this.props.max, actualValue);
        }
        if (_this.props.min !== null) {
          actualValue = Math.max(_this.props.min, actualValue);
        }
        _this.props.onChange(actualValue);
      }
    }, _this.handleFloatClick = function (event) {
      var _event$target$getBoun2 = event.target.getBoundingClientRect(),
          bottom = _event$target$getBoun2.bottom;

      var scrollParent = getScrollParent(event.target);
      var height = window.innerHeight;
      if (scrollParent) {
        height = scrollParent.getBoundingClientRect().bottom;
      }
      var floatAbove = bottom + selectorBottom > height;
      _this.setState({ floatOpen: true, integerOpen: false, floatAbove: floatAbove });
    }, _this.handleFloatItemClick = function (strValue, event) {
      event.stopPropagation();
      _this.setState({ floatOpen: false });
      if (_this.props.onChange) {
        var _this$getValues2 = _this.getValues(),
            integerPart = _this$getValues2.integerPart,
            negative = _this$getValues2.negative;

        var value = parseFloat(strValue);

        var actualValue = (value + Math.abs(integerPart)) * (negative ? -1 : 1);
        if (_this.props.max !== null) {
          actualValue = Math.min(_this.props.max, actualValue);
        }
        if (_this.props.min !== null) {
          actualValue = Math.max(_this.props.min, actualValue);
        }
        _this.props.onChange(actualValue);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TemperatureSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          isMinNegative = _props.isMinNegative,
          isMaxNegative = _props.isMaxNegative,
          disabled = _props.disabled;

      var _getValues = this.getValues(),
          integerPart = _getValues.integerPart,
          floatPart = _getValues.floatPart,
          negative = _getValues.negative;

      var tempIntegerRange = [this.props.lowerLimit, this.props.upperLimit];
      var floatAbove = this.state.floatAbove;
      var integerAbove = this.state.integerAbove;
      var tempFloatRange = [0, 10];

      if (this.props.max !== null) {
        tempIntegerRange[1] = Math.floor(Math.abs(this.props.max)) * (this.props.max < 0 ? -1 : 1);

        if (integerPart === tempIntegerRange[1]) {
          if (isMaxNegative !== isMinNegative) {
            tempFloatRange = [0, 10];
          } else {
            if (negative) {
              tempFloatRange = [Math.round(Math.abs(this.props.max - tempIntegerRange[1]) * 10) + 1, 10];
            }
            if (!negative) {
              tempFloatRange = [0, Math.round(Math.abs(this.props.max - tempIntegerRange[1]) * 10 + 1)];
            }
          }
        }
      }

      if (this.props.min !== null) {
        tempIntegerRange[0] = Math.floor(Math.abs(this.props.min)) * (this.props.min < 1 ? -1 : 1);

        if (integerPart === tempIntegerRange[0]) {
          if (isMaxNegative !== isMinNegative) {
            tempFloatRange = [0, 10];
          } else {
            if (negative) {
              tempFloatRange = [0, Math.round(Math.abs(this.props.min - tempIntegerRange[0]) * 10) + 1];
              if (type) {
                tempFloatRange[0] -= 1;
              }
            }
            if (!negative) {
              tempFloatRange = [Math.round(Math.abs(this.props.min - tempIntegerRange[0]) * 10) + 1, 10];
              if (type) {
                tempFloatRange[0] -= 1;
              }
            }
          }
        }
      }

      tempIntegerRange[1] += 1;

      var menuTempIntegerRange = range.apply(undefined, tempIntegerRange);
      var zeroIndex = menuTempIntegerRange.indexOf(0);
      if (this.props.min < zeroIndex) {
        menuTempIntegerRange.splice(zeroIndex, 0, '-0');
      }
      return React.createElement(
        'div',
        { className: css(styles.container, this.props.style), ref: this.setMainRef },
        React.createElement(ClickOutside, { onClickOutside: this.handleClickOutside }),
        React.createElement(
          'div',
          {
            className: 'temperature-select__inner-container ' + css(styles.innerContainer, disabled && styles.disabled),
            role: 'button',
            tabIndex: 0,
            'data-id': 'temperature-select-integer-' + this.props.id,
            onClick: disabled ? null : this.handleIntegerClick
          },
          React.createElement(
            'span',
            { className: css(styles.value) },
            this.props.value !== null ? React.createElement(
              Fragment,
              null,
              negative ? '- ' : '',
              Math.abs(integerPart)
            ) : null
          ),
          this.state.integerOpen ? React.createElement(
            'div',
            { className: css(styles.menuContainer, styles.integerMenuContainer, integerAbove && styles.tempPickerContainerAbove, disabled && styles.disabled) },
            React.createElement(Menu, {
              items: menuTempIntegerRange.map(function (i) {
                return { value: i, label: i.toString() };
              }),
              currentValue: integerPart,
              alignContent: 'right',
              itemStyle: styles.numeralButton,
              onChange: this.handleIntegerItemClick
            })
          ) : null
        ),
        React.createElement(
          'span',
          { className: css(styles.delimeter) },
          '.'
        ),
        React.createElement(
          'div',
          {
            className: 'temperature-select__inner-container ' + css(styles.innerContainer, styles.floatContainer, disabled && styles.disabled),
            role: 'button',
            tabIndex: 0,
            'data-id': 'temperature-select-decimal-' + this.props.id,
            onClick: disabled ? null : this.handleFloatClick
          },
          React.createElement(
            'span',
            { className: css(styles.value) },
            this.props.value !== null ? Math.floor(floatPart * 10) : null
          ),
          this.state.floatOpen ? React.createElement(
            'div',
            { className: css(styles.menuContainer, styles.floatMenuContainer, floatAbove && styles.tempPickerContainerAbove) },
            React.createElement(Menu, {
              items: range.apply(undefined, _toConsumableArray(tempFloatRange)).map(function (i) {
                return { value: i / 10, label: '.' + i };
              }),
              currentValue: floatPart,
              alignContent: 'right',
              itemStyle: styles.numeralButton,
              onChange: this.handleFloatItemClick
            })
          ) : null
        ),
        React.createElement(
          'span',
          { className: css(styles.degrees) },
          '\xB0',
          this.props.temperatureType
        )
      );
    }
  }]);

  return TemperatureSelect;
}(Component);

TemperatureSelect.propTypes = {
  value: PropTypes.number,
  style: stylePropType,
  min: PropTypes.number,
  max: PropTypes.number,
  isMaxNegative: PropTypes.bool,
  isMinNegative: PropTypes.bool,
  disabled: PropTypes.bool,
  upperLimit: PropTypes.number,
  lowerLimit: PropTypes.number,
  temperatureType: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  handleNegative: PropTypes.func
};
TemperatureSelect.defaultProps = {
  value: null,
  style: null,
  min: null,
  max: null,
  disabled: false,
  isMaxNegative: false,
  isMinNegative: false,
  upperLimit: 140,
  lowerLimit: -200,
  temperatureType: 'C',
  type: null,
  id: null,
  onChange: null,
  handleNegative: function handleNegative() {}
};


styles = StyleSheet.create({
  container: {
    fontSize: '1.4rem',
    display: 'flex'
  },

  innerContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '5rem',
    height: '4.6rem',
    outline: 0,
    cursor: 'pointer',
    backgroundColor: 'white',

    border: '2px solid ' + TSS_BLUE_1(),

    ':hover': {
      backgroundColor: TSS_BLUE_1(0.5)
    },

    ':nth-of-type(1n) + .duration-select__inner-container': {
      marginLeft: '0.6rem'
    }
  },

  floatContainer: {
    width: '4rem'
  },

  menuContainer: {
    position: 'absolute',
    top: '100%',
    left: -2,
    right: -2,
    zIndex: 1
  },

  floatMenuContainer: {
    right: -25
  },

  integerMenuContainer: {
    left: -25
  },

  delimeter: {
    fontSize: '1.6rem',
    fontWeight: 600,
    margin: '0 0.2rem',
    alignSelf: 'flex-end',
    paddingBottom: '1.2rem'
  },

  degrees: {
    fontSize: '1.4rem',
    margin: '0 0 0 0.4rem',
    alignSelf: 'flex-end',
    paddingBottom: '1.5rem'
  },

  disabled: {
    backgroundColor: TSS_BLUE_2(),
    color: TSS_DARK_BLUE(0.5),
    cursor: 'not-allowed'
  },

  tempPickerContainerAbove: {
    top: 'initial',
    bottom: '100%',
    marginBottom: 1
  },

  numeralButton: {
    padding: '0.3rem 1.8rem 0.3rem 1rem'
  }
});

export default TemperatureSelect;